import { Injectable } from '@angular/core';
import { ZoningCodeService } from './zoning-code.service';
import { HttpParams, HttpClient } from '@angular/common/http';

import { environment } from '../../../environments/environment';

import { ZoningCodeAttribute } from '../../models';
import * as _ from 'lodash';
import { AttributeService } from './attribute.service';

const API = environment.ZONEIQ_CALIBRATION + '/v1/zoning-code-attribute';

@Injectable({
    providedIn: 'root'
})
export class ZoningCodeAttributeService extends AttributeService<ZoningCodeAttribute> {
    constructor(protected readonly http: HttpClient, private readonly zoningCodeService: ZoningCodeService) {
        super(http, API, ZoningCodeAttribute);
    }

    get hasZoningCode() {
        return !!this.zoningCodeService.selectedZoningCode;
    }

    get zoningCodeId() {
        return this.hasZoningCode && this.zoningCodeService.selectedZoningCode.Id;
    }

    getAttributesForZoningCodeField(tableFieldId: number, tableType: number) {
        if (!tableFieldId) {
            return;
        }
        const params = new HttpParams()
            .set('zoningCodeId', this.zoningCodeId.toString())
            .set('tableType', tableType.toString())
            .set('tableFieldId', tableFieldId.toString());

        return super.getByParameters(params);
    }

    addOrUpdate(attributesToSave: ZoningCodeAttribute[]) {
        attributesToSave.forEach(attribute => {
            attribute.ZoningCodeId = this.zoningCodeId;
        });
        return super.addOrUpdate(attributesToSave);
    }

    deleteAttributes(attributeIds: number[]) {
        return super.deleteAttributes(attributeIds);
    }
}
